import { Degree } from '@/models/Degree';
import { IState } from './interfaces/IState';
import { Organisation } from '@/models/Organisation';
import { PaginationDefinition } from './PaginationDefinition';

export class State implements IState {

	public readonly degree: Degree;
	public readonly organisations: readonly Organisation[];
	public readonly totalSearchResults: number | undefined;
	public readonly currentPage: number;

	public constructor() {
		this.degree = Degree.forPortal();
		this.organisations = [];
		this.currentPage = +PaginationDefinition.DEFAULT_PAGE_NUMBER;
	}
}
